/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { PushDeviceFromJSON, PushSubscriptionCreateToJSON, PushSubscriptionResponseFromJSON, VapidPublicKeyResponseFromJSON, } from '../models/index';
/**
 *
 */
export class PushNotificationsApi extends runtime.BaseAPI {
    /**
     * Revoke one of the current user\'s devices by id.  Used from the device list to remove a device other than the current browser (which uses /unsubscribe with its own endpoint).
     * Delete Subscription
     */
    deleteSubscriptionApiV1PushSubscriptionsSubscriptionIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subscriptionId'] == null) {
                throw new runtime.RequiredError('subscriptionId', 'Required parameter "subscriptionId" was null or undefined when calling deleteSubscriptionApiV1PushSubscriptionsSubscriptionIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/push/subscriptions/{subscription_id}`.replace(`{${"subscription_id"}}`, encodeURIComponent(String(requestParameters['subscriptionId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Revoke one of the current user\'s devices by id.  Used from the device list to remove a device other than the current browser (which uses /unsubscribe with its own endpoint).
     * Delete Subscription
     */
    deleteSubscriptionApiV1PushSubscriptionsSubscriptionIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteSubscriptionApiV1PushSubscriptionsSubscriptionIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Return the VAPID public key for the frontend to subscribe.
     * Get Vapid Public Key
     */
    getVapidPublicKeyApiV1PushVapidPublicKeyGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/push/vapid-public-key`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => VapidPublicKeyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Return the VAPID public key for the frontend to subscribe.
     * Get Vapid Public Key
     */
    getVapidPublicKeyApiV1PushVapidPublicKeyGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getVapidPublicKeyApiV1PushVapidPublicKeyGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * List the current user\'s push-subscribed devices.  Encryption keys are never returned. Ordered most recently used first, falling back to creation time for devices that never received a push.
     * List Subscriptions
     */
    listSubscriptionsApiV1PushSubscriptionsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/push/subscriptions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PushDeviceFromJSON));
        });
    }
    /**
     * List the current user\'s push-subscribed devices.  Encryption keys are never returned. Ordered most recently used first, falling back to creation time for devices that never received a push.
     * List Subscriptions
     */
    listSubscriptionsApiV1PushSubscriptionsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listSubscriptionsApiV1PushSubscriptionsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Register a push subscription for the current user.  A user can have multiple subscriptions (one per device/browser). Each device/browser generates a unique push endpoint URL. If the same endpoint already exists (same browser re-subscribing), we update the keys instead of creating a duplicate.
     * Subscribe
     */
    subscribeApiV1PushSubscribePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['pushSubscriptionCreate'] == null) {
                throw new runtime.RequiredError('pushSubscriptionCreate', 'Required parameter "pushSubscriptionCreate" was null or undefined when calling subscribeApiV1PushSubscribePost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters['userAgent'] != null) {
                headerParameters['user-agent'] = String(requestParameters['userAgent']);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/push/subscribe`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PushSubscriptionCreateToJSON(requestParameters['pushSubscriptionCreate']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PushSubscriptionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Register a push subscription for the current user.  A user can have multiple subscriptions (one per device/browser). Each device/browser generates a unique push endpoint URL. If the same endpoint already exists (same browser re-subscribing), we update the keys instead of creating a duplicate.
     * Subscribe
     */
    subscribeApiV1PushSubscribePost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.subscribeApiV1PushSubscribePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Send a test push notification to the current user.
     * Test Push
     */
    testPushApiV1PushTestPostRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/push/test`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Send a test push notification to the current user.
     * Test Push
     */
    testPushApiV1PushTestPost(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.testPushApiV1PushTestPostRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Remove a push subscription for the current user.
     * Unsubscribe
     */
    unsubscribeApiV1PushUnsubscribeDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['pushSubscriptionCreate'] == null) {
                throw new runtime.RequiredError('pushSubscriptionCreate', 'Required parameter "pushSubscriptionCreate" was null or undefined when calling unsubscribeApiV1PushUnsubscribeDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/push/unsubscribe`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: PushSubscriptionCreateToJSON(requestParameters['pushSubscriptionCreate']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove a push subscription for the current user.
     * Unsubscribe
     */
    unsubscribeApiV1PushUnsubscribeDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.unsubscribeApiV1PushUnsubscribeDeleteRaw(requestParameters, initOverrides);
        });
    }
}
